import { Fragment, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import Collapse from "@material-ui/core/Collapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChargingStation } from "@fortawesome/free-solid-svg-icons";

import { ProposalData, AuthContextProps } from "../../shared/data/types";

import "./PropDashUcItem.scss";

interface PropDashAddItemProps {
  auth: AuthContextProps;
  index: number;
  loadedAddItem: ProposalData["additionalItems"][0];
}

export const PropDashAddItem = (props: PropDashAddItemProps) => {
  const { loadedAddItem, auth, index } = props;
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Fragment>
      <div
        className="cust-prop-item-prop"
        onClick={(e) => {
          setOpen(!open);
        }}
      >
        <div className="cust-prop-item-prop__data">
          <p className="cust-prop-item-prop__data-item cust-prop-item-prop__data-item--thin">
            {loadedAddItem?.item || ""}
          </p>
          <div className="cust-prop-item-prop__user-data">
            <FontAwesomeIcon
              icon={faChargingStation}
              style={{ fontSize: "1.25rem", marginRight: "0.25rem" }}
            />
            <div className="cust-prop-item-prop__user-data-content">
              <p className="cust-prop-item-prop__data-item">
                Qtd: {loadedAddItem?.quantity}
              </p>
            </div>
          </div>
        </div>
        <div className="cust-prop-item-prop__controls">
          <IconButton
            size="small"
            title={open ? "Ver Mais" : "Fechar"}
            className={`table__item-action${open ? "--open" : ""}`}
            onClick={(e) => {
              setOpen(!open);
              e.stopPropagation();
            }}
          >
            <ExpandMoreRoundedIcon style={{ fontSize: "22px" }} />
          </IconButton>
        </div>
        <div className="cust-prop-item-prop__details">
          <Collapse in={open}>
            <div className="cust-prop-item-prop__details-content">
              <p className="cust-prop-item-prop__data-item cust-prop-item-prop__data-item--thin">
                Fabricante:{" "}
                <span className="cust-prop-item-prop__data-item--highlight">
                  {loadedAddItem?.manufacter || "Nenhum"}
                </span>
              </p>
              <p className="cust-prop-item-prop__data-item cust-prop-item-prop__data-item--thin">
                Detalhe:{" "}
                <span className="cust-prop-item-prop__data-item--highlight">
                  {loadedAddItem?.detail || "Nenhum"}
                </span>
              </p>
            </div>
          </Collapse>
        </div>
      </div>
    </Fragment>
  );
};
